<template>
  <div class="flex flex-col gap-2">
    <UiAccordeon v-for="(item, i) in items" :key="i">
      <template #title>
        <span v-html="item.question" />
      </template>

      <h3 v-html="item.answer"></h3>
    </UiAccordeon>
  </div>
</template>

<script setup lang="ts">
interface Props {
  items?: any[];
}

withDefaults(defineProps<Props>(), {
  items: () => [],
});
</script>
